/**
 * @generated SignedSource<<482db4ad630b51a13cdf63f880f6c4df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MoreActionsMenuNote_viewer$data = {
  readonly account: {
    readonly allowAiFeatures: boolean;
  };
  readonly user: {
    readonly id: string;
    readonly isGuest: boolean;
  };
  readonly " $fragmentSpreads": FragmentRefs<"DeleteMeeting_viewer" | "LockNote_viewer" | "SaveAsTemplate_viewer" | "VersionHistory_viewer">;
  readonly " $fragmentType": "MoreActionsMenuNote_viewer";
};
export type MoreActionsMenuNote_viewer$key = {
  readonly " $data"?: MoreActionsMenuNote_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MoreActionsMenuNote_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MoreActionsMenuNote_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowAiFeatures",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SaveAsTemplate_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VersionHistory_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LockNote_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteMeeting_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "87668469b3c20f41831d40f81170d12e";

export default node;
